var _defs, _clipPath, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoYoutube = function SvgIcoYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ico_youtube_svg__a",
    d: "M0 0h192v192H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ico_youtube_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ico_youtube_svg__a",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ico_youtube_svg__b)",
    fill: "#282828",
    d: "M180.322 53.363c-2.024-7.622-7.987-13.624-15.561-15.661C151.037 34 96 34 96 34s-55.037 0-68.762 3.702c-7.573 2.037-13.537 8.039-15.561 15.661C8 67.177 8 96 8 96s0 28.822 3.677 42.638c2.024 7.621 7.988 13.623 15.561 15.661C40.963 158 96 158 96 158s55.037 0 68.762-3.701c7.573-2.038 13.536-8.04 15.561-15.661C184 124.822 184 96 184 96s0-28.823-3.678-42.637"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ico_youtube_svg__b)",
    fill: "#FFF",
    d: "m78 122.169 46-26.168-46-26.17z"
  })));
};
export default SvgIcoYoutube;